import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useState } from 'react';

import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { useSubscription } from '@sorare/core/src/hooks/useSubscription';

import { MissionToast } from './MissionToast';
import type {
  CurrentUserTaskWasUpdatedSubscription,
  CurrentUserTaskWasUpdatedSubscriptionVariables,
} from './__generated__/index.graphql';

const CURRENT_USER_TASK_WAS_UPDATED_SUBSCRIPTION = gql`
  subscription CurrentUserTaskWasUpdatedSubscription {
    currentUserTaskWasUpdated {
      previousProgress
      task {
        id
        ...MissionToast_taskInterface
      }
    }
  }
  ${MissionToast.fragments.taskInterface}
` as TypedDocumentNode<
  CurrentUserTaskWasUpdatedSubscription,
  CurrentUserTaskWasUpdatedSubscriptionVariables
>;

type CurrentUserTaskWasUpdatedPayload = NonNullable<
  CurrentUserTaskWasUpdatedSubscription['currentUserTaskWasUpdated']
>;

export const CurrentUserTaskUpdatedToast = () => {
  const [accumulatedData, setAccumulatedData] = useState<
    CurrentUserTaskWasUpdatedPayload[]
  >([]);
  const {
    flags: { useMissionToasts = false },
  } = useFeatureFlags();

  const { isIosApp } = useIsMobileApp();

  //todo Damien in follow up MR check if there is a dialog currently displayed
  const isDialogVisible = false;

  const currentlyVisibleToastData = accumulatedData.at(0);

  useSubscription(CURRENT_USER_TASK_WAS_UPDATED_SUBSCRIPTION, {
    skip: !useMissionToasts || isIosApp,
    onData({ data }) {
      const { currentUserTaskWasUpdated } = data.data || {};
      if (currentUserTaskWasUpdated) {
        setAccumulatedData(prev => [...prev, currentUserTaskWasUpdated]);
      }
    },
  });
  if (!currentlyVisibleToastData) {
    return null;
  }

  return (
    <MissionToast
      key={currentlyVisibleToastData.task.id}
      open={!!accumulatedData.length && !isDialogVisible && useMissionToasts}
      onClose={() => {
        setAccumulatedData(prev => prev.slice(1));
      }}
      task={currentlyVisibleToastData.task}
      previousProgress={currentlyVisibleToastData.previousProgress ?? 0}
    />
  );
};
